<div class="login-container flex justify-center items-center">
    <div class="flex flex-col items-center gap-12">
        <div class="text-center">
            <div class="headline">SESAMMTOOL 3</div>
            <div class="subheadline mt-2">Model and visualize SESAMM</div>
        </div>
        <p-card class="w-[30rem] text-center shadow-md">
            <p class="mb-8" style="font-size: var(--font-size-lg)">Please sign in to continue.</p>
            <p-button
                size="large"
                styleClass="px-20 py-4 w-full justify-center font-size: var(--font-size-md)"
                (click)="login()"
            >
                Sign In
            </p-button>
            <div class="mt-4" style="font-size: var(--font-size-sm)">
                Don't have access?
                <a
                    class="font-semibold text-[var(--p-primary-color)] underline underline-offset-[0.15rem]"
                    href="https://welcome.collaborationlayer-traton.com/request-management/application/cognito/SESAMM-TOOL"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Request Access
                    <i class="pi pi-external-link" style="font-size: 0.7rem"></i>
                </a>
            </div>
        </p-card>
    </div>
</div>
